module.exports = __webpack_public_path__ + "img/login.1f165080.svg";